<template>
  <div class="animated fadeIn pb-8 edit-product">
    <div>
      <v-card class="common-card">
        <div>
          <h4 class="c-grey">ویرایش محصول</h4>
        </div>
        <hr class="mt-5" />

        <v-tabs v-model="tab" :vertical="deviceType == 'mobile'">
          <v-tab> اطلاعات محصول </v-tab>
          <v-tab @click="productSales()"> گزارش فروش </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" touchless>
          <v-tab-item class="mt-5">
            <v-row>
              <v-col md="6" lg="6">
                <div class="d-flex align-items-end mb-6">
                  <div
                    class="img-box pointer"
                    @click="$refs.editProductImage.$refs.input.click()"
                  >
                    <img
                      height="150"
                      width="150"
                      class="img"
                      :src="
                        selectedItem.pictureId
                          ? selectedItem.pictureUrl
                          : '/no-image.png'
                      "
                    />
                    <v-icon x-large class="img-icon white--text"
                      >mdi-camera</v-icon
                    >
                    <div class="img-loading" v-if="editMainImageLoading">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                        :size="40"
                      ></v-progress-circular>
                      <h6 class="mt-4 grey--text text--darken-4">
                        در حال بارگذاری...
                      </h6>
                    </div>
                  </div>
                  <div class="me-4 me-sm-0 pe-3">
                    <v-btn
                      class="orange-mainBtn pa-3 ms-sm-4 ms-0"
                      @click="$refs.editProductImage.$refs.input.click()"
                    >
                      <v-icon class="me-2">mdi-camera-outline</v-icon>
                      بارگذاری تصویر برگزیده
                    </v-btn>
                  </div>
                  <v-file-input
                    v-show="false"
                    @change="editProductMainImageUpload(editMainImage)"
                    v-model="editMainImage"
                    ref="editProductImage"
                  ></v-file-input>
                </div>
              </v-col>
              <v-col md="6" lg="6" class="d-flex justify-end">
                <v-btn
                  color="teal"
                  class="white--text"
                  @click="openDialog('increase')"
                >
                  <v-icon>mdi-plus</v-icon>
                  افزایش موجودی
                </v-btn>
                <v-btn
                  color="warning"
                  @click="openDialog('decrease')"
                  class="ms-4"
                >
                  <v-icon>mdi-minus</v-icon>
                  کاهش موجودی
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="4" sm="6" xs="12" cols="12">
                <label class="primary--text font-weight-bold"
                  ><span class="red--text">*</span> نام محصول:</label
                >
                <v-text-field
                  placeholder="نام محصول"
                  outlined
                  dense
                  hide-details
                  v-model="selectedItem.name"
                ></v-text-field>
              </v-col>
              <v-col md="4" sm="6" xs="12" cols="12">
                <label class="primary--text font-weight-bold">
                  زیرعنوان:
                </label>
                <v-text-field
                  placeholder="زیر عنوان"
                  outlined
                  dense
                  hide-details
                  v-model="selectedItem.subTitle"
                ></v-text-field>
              </v-col>
              <v-col md="4" sm="6" xs="12" cols="12">
                <label class="primary--text font-weight-bold"> موضوع:</label>
                <v-text-field
                  placeholder="موضوع"
                  outlined
                  dense
                  hide-details
                  v-model="selectedItem.subject"
                ></v-text-field>
              </v-col>
              <v-col md="4" sm="6" xs="12" cols="12">
                <label class="primary--text font-weight-bold">
                  <span> قیمت: </span>
                </label>
                <v-text-field
                  v-model.number="selectedItem.price"
                  density="compact"
                  outlined
                  dense
                  variant="solo"
                  class="input_panel_product"
                  type="number"
                  placeholder="قیمت"
                ></v-text-field>
              </v-col>
              <v-col md="4" sm="6" xs="12" cols="12">
                <label class="primary--text font-weight-bold">
                  <span> شابک: </span>
                </label>
                <v-text-field
                  v-model.number="selectedItem.isbn"
                  density="compact"
                  outlined
                  dense
                  variant="solo"
                  class="input_panel_product"
                  type="text"
                  placeholder="شابک"
                ></v-text-field>
              </v-col>
              <v-col md="4" sm="6" xs="12" cols="12">
                <label class="primary--text font-weight-bold">
                  <span> سال انتشار: </span>
                </label>
                <v-text-field
                  v-model.number="selectedItem.publishYear"
                  density="compact"
                  outlined
                  dense
                  variant="solo"
                  class="input_panel_product"
                  type="number"
                  placeholder="سال انتشار"
                ></v-text-field>
              </v-col>
              <v-col md="4" sm="6" xs="12" cols="12">
                <label class="primary--text font-weight-bold">
                  <span> انتشارات: </span>
                </label>
                <v-select
                  :items="publishers"
                  v-model="selectedItem.publisherId"
                  density="compact"
                  outlined
                  dense
                  variant="solo"
                  class="input_edit_list"
                  append-inner-icon="mdi-menu-down"
                  item-value="id"
                  item-text="name"
                  placeholder=" انتشارات"
                >
                </v-select>
              </v-col>
              <v-col md="4" sm="6" xs="12" cols="12">
                <label class="primary--text font-weight-bold">
                  <span> مقطع تحصیلی: </span>
                </label>
                <v-select
                  :items="educationalGrades"
                  v-model="selectedItem.educationalGrade"
                  density="compact"
                  outlined
                  dense
                  variant="solo"
                  class="input_edit_list"
                  append-inner-icon="mdi-menu-down"
                  item-value="key"
                  item-text="text"
                  placeholder=" مقطع تحصیلی"
                >
                </v-select>
              </v-col>
              <v-col
                md="4"
                sm="6"
                xs="12"
                cols="12"
                v-if="selectedItem.educationalGrade != 'child'"
              >
                <label class="primary--text font-weight-bold">
                  <span> پایه تحصیلی: </span>
                </label>
                <v-autocomplete
                  :items="educationalStage"
                  v-model="educationalStages"
                  density="compact"
                  outlined
                  dense
                  multiple
                  variant="solo"
                  class="input_edit_list"
                  append-inner-icon="mdi-menu-down"
                  item-value="key"
                  item-text="text"
                  chips
                  color="primary"
                  placeholder=" پایه تحصیلی"
                >
                  <template #selection="{ item }">
                    <v-chip small color="primary">{{ item.text }}</v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col
                md="4"
                sm="6"
                xs="12"
                cols="12"
                v-if="selectedItem.educationalGrade != 'child'"
              >
                <label class="primary--text font-weight-bold">
                  <span> رشته تحصیلی: </span>
                </label>
                <v-select
                  :items="major"
                  v-model="selectedItem.major"
                  density="compact"
                  outlined
                  dense
                  variant="solo"
                  class="input_edit_list"
                  append-inner-icon="mdi-menu-down"
                  item-value="key"
                  item-text="text"
                  placeholder=" رشته تحصیلی"
                >
                </v-select>
              </v-col>
              <v-col md="4" sm="6" xs="12" cols="12">
                <label class="primary--text font-weight-bold">
                  <span> سری: </span>
                </label>
                <v-select
                  :disabled="!selectedItem.publisherId"
                  :items="divisions"
                  v-model="selectedItem.divisionId"
                  density="compact"
                  outlined
                  dense
                  variant="solo"
                  class="input_edit_list"
                  append-inner-icon="mdi-menu-down"
                  item-value="id"
                  item-text="name"
                  placeholder="  سری"
                >
                </v-select>
              </v-col>
              <v-col
                md="4"
                sm="6"
                xs="12"
                cols="12"
                v-if="selectedItem.educationalGrade != 'child'"
              >
                <label class="primary--text font-weight-bold">
                  <span> مخصوص کنکور: </span>
                </label>
                <v-select
                  :items="entranceExam"
                  v-model="selectedItem.entranceExam"
                  density="compact"
                  outlined
                  dense
                  variant="solo"
                  class="input_edit_list"
                  append-inner-icon="mdi-menu-down"
                  item-value="key"
                  item-text="text"
                  placeholder=" مخصوص کنکور"
                >
                </v-select>
              </v-col>
              <v-col
                md="4"
                sm="6"
                xs="12"
                cols="12"
                v-if="selectedItem.educationalGrade != 'child'"
              >
                <label class="primary--text font-weight-bold">
                  <span> رشته کنکور: </span>
                </label>
                <v-select
                  :items="entranceExamMajor"
                  v-model="selectedItem.entranceExamMajor"
                  density="compact"
                  outlined
                  dense
                  variant="solo"
                  class="input_edit_list"
                  append-inner-icon="mdi-menu-down"
                  item-value="key"
                  item-text="text"
                  placeholder=" رشته کنکور"
                >
                </v-select>
              </v-col>
              <v-col
                md="4"
                sm="6"
                xs="12"
                cols="12"
                v-if="selectedItem.educationalGrade != 'child'"
              >
                <label class="primary--text font-weight-bold">
                  <span> نوع کتاب: </span>
                </label>
                <v-select
                  :items="generalSubject"
                  v-model="selectedItem.generalSubject"
                  density="compact"
                  outlined
                  dense
                  variant="solo"
                  class="input_edit_list"
                  append-inner-icon="mdi-menu-down"
                  item-value="key"
                  item-text="text"
                  placeholder=" نوع کتاب"
                >
                </v-select>
              </v-col>
              <v-col md="4" sm="6" xs="12" cols="12">
                <label class="primary--text font-weight-bold">
                  <span> نویسندگان: </span>
                </label>
                <v-autocomplete
                  :items="authors"
                  v-model="selectedItem.authors"
                  density="compact"
                  outlined
                  dense
                  multiple
                  variant="solo"
                  class="input_edit_list"
                  append-inner-icon="mdi-menu-down"
                  item-value="id"
                  item-text="name"
                  chips
                  color="primary"
                  placeholder="نویسندگان"
                >
                  <template #selection="{ item }">
                    <v-chip small color="primary">{{ item.name }}</v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col md="4" sm="6" xs="12" cols="12">
                <label class="primary--text font-weight-bold"
                  >برچسب‌های محصول:</label
                >
                <div class="d-flex flex-row">
                  <v-text-field
                    outlined
                    dense
                    height="40"
                    hide-details
                    placeholder="برچسب محصول"
                    v-model="editNewTag"
                    @keyup.enter="editNewTag ? addNewTag('selectedItem') : ''"
                  >
                    <template slot="label">
                      <div style="font-size: 14px">برچسب‌ جدید</div>
                    </template>
                  </v-text-field>
                  <v-btn
                    class="ms-2 green-mainBtn"
                    width="60"
                    min-width="40"
                    height="40"
                    :disabled="!editNewTag"
                    @click="addNewTag('selectedItem')"
                    >ثبت
                  </v-btn>
                </div>

                <div v-if="selectedItem.tags">
                  <v-row v-if="selectedItem.tags.length">
                    <v-col class="d-flex flex-wrap">
                      <span v-show="false">{{ reactivity }}</span>
                      <div
                        class="orange-badge me-2 mt-2"
                        v-for="(item, index) in selectedItem.tags"
                        :key="index"
                      >
                        <span>{{ item }}</span>
                        <span
                          ><v-icon
                            @click="removeTag('selectedItem', index)"
                            color="primary"
                            small
                            class="ps-1"
                            >mdi-close</v-icon
                          ></span
                        >
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col md="4" sm="6" xs="12" cols="12">
                <label class="primary--text font-weight-bold">
                  <span> لینک ویدیوی آپارات توضیحات مولف: </span>
                </label>
                <v-text-field
                  v-model.number="selectedItem.aparatAuthorLink"
                  outlined
                  dense
                  variant="solo"
                  class="input_panel_product"
                  :rules="linkRules"
                  placeholder="لینک ویدیوی آپارات توضیحات مولف"
                ></v-text-field>
              </v-col>
              <v-col md="4" sm="6" xs="12" cols="12">
                <label class="primary--text font-weight-bold">
                  <span> لینک ویدیوی آپارات توضیحات کارشناس : </span>
                </label>
                <v-text-field
                  v-model.number="selectedItem.aparatExpertLink"
                  outlined
                  dense
                  variant="solo"
                  class="input_panel_product"
                  :rules="linkRules"
                  placeholder=" لینک ویدیوی آپارات توضیحات کارشناس"
                ></v-text-field>
              </v-col>
              <v-col md="4" sm="6" xs="12" cols="12">
                <label class="primary--text font-weight-bold">
                  <span> موجودی اولیه: </span>
                </label>
                <v-text-field
                  disabled
                  v-model.number="selectedItem.amount"
                  density="compact"
                  outlined
                  dense
                  variant="solo"
                  class="input_panel_product"
                  type="number"
                  placeholder="موجودی اولیه"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <label class="primary--text font-weight-bold">
                  <span> توضیحات open graph محصول: </span>
                </label>
                <v-textarea
                  outlined
                  dense
                  v-model="selectedItem.ogDescription"
                  placeholder="توضیحات open graph محصول"
                >
                </v-textarea>
              </v-col>
              <v-col cols="12">
                <label class="primary--text font-weight-bold">
                  <span> توضیحات محصول: </span>
                </label>
                <!-- <v-textarea
                  outlined
                  dense
                  v-model="selectedItem.onlineShopDescription"
                  placeholder="توضیحات محصول"
                >
                </v-textarea> -->
                <vue-editor
                  v-model="selectedItem.onlineShopDescription"
                  :editor-toolbar="customToolbar"
                />
              </v-col>
              <v-col cols="12">
                <label class="primary--text font-weight-bold">
                  <span> توضیحات فروش محصول: </span>
                </label>
                <vue-editor
                  v-model="selectedItem.sellDescription"
                  :editor-toolbar="customToolbar"
                />
              </v-col>
            </v-row>
            <div class="custom-table"></div>
            <div class="d-flex justify-end mt-3">
              <div class="text-left pb-3 px-4 mt-3 d-flex justify-end">
                <v-btn
                  @click="editItem()"
                  class="green-mainBtn white--text"
                  width="90"
                >
                  ذخیره
                </v-btn>
                <v-btn
                  class="red-mainBtn white--text ms-2"
                  @click="cancelEdit()"
                  width="90"
                >
                  لغو
                </v-btn>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item class="mt-5">
            <v-row
              ><v-col>
                <div class="text-left" md="4" cols="12">
                  <vue-excel-xlsx
                    v-if="customers.length"
                    :data="customers"
                    style="width: 180px; height: 43px"
                    class="darkGreen-mainBtn white--text py-2 mb-6"
                    :columns="excelFields"
                    :filename="'فروش محصول'"
                    sheetname="فروش محصول"
                  >
                    <v-icon class="white--text">mdi-file-excel</v-icon> دریافت
                    اکسل
                  </vue-excel-xlsx>
                </div>
              </v-col></v-row
            >
            <v-row>
              <v-col class="date_picker pb-0" md="4" cols="12">
                <label class="title-form-panel">از تاریخ:</label>
                <span id="fromDate"
                  ><v-text-field
                    dense
                    outlined
                    v-model="startDate"
                    append-icon="mdi-calendar"
                    class="date-input"
                    placeholder="از تاریخ"
                  ></v-text-field
                ></span>
                <date-picker
                  element="fromDate"
                  v-model="startDate"
                  color="#6200ea"
                ></date-picker>
              </v-col>
              <v-col class="date_picker pb-0" md="4" cols="12">
                <label class="title-form-panel">تا تاریخ:</label>
                <span id="toDate"
                  ><v-text-field
                    dense
                    outlined
                    v-model="endDate"
                    append-icon="mdi-calendar"
                    class="date-input"
                    placeholder="تا تاریخ"
                  ></v-text-field
                ></span>
                <date-picker
                  element="toDate"
                  v-model="endDate"
                  color="#6200ea"
                ></date-picker>
              </v-col>
              <v-col class="date_picker pb-0 mt-7" md="4" cols="12">
                <v-btn
                  @click="productSales"
                  class="primary-mainBtn"
                  block
                  height="40"
                  :disabled="!startDate || !endDate"
                  >اعمال</v-btn
                >
              </v-col>
            </v-row>
            <hr />
            <v-row>
              <v-col lg="4" md="6" cols="12" align="center" justify="center">
                <v-card>
                  <div>
                    <div class="purple-iconBox">
                      <v-icon>mdi-paper-roll</v-icon>
                    </div>
                    <span class="box-header">تعداد کل فاکتورها</span>
                  </div>
                  <h5>{{ Number(totalInvoices).toLocaleString() }}</h5>
                </v-card>
              </v-col>
              <v-col lg="4" md="6" cols="12" align="center" justify="center">
                <v-card>
                  <div>
                    <div class="blue-iconBox">
                      <v-icon>mdi-receipt</v-icon>
                    </div>
                    <span class="box-header">تعداد قلم خریداری شدی</span>
                  </div>
                  <h5>{{ Number(totalSellAmount).toLocaleString() }}</h5>
                </v-card>
              </v-col>
              <v-col lg="4" md="6" cols="12" align="center" justify="center">
                <v-card>
                  <div>
                    <div class="green-iconBox">
                      <v-icon>mdi-cash-multiple</v-icon>
                    </div>
                    <span class="box-header">مجموع درآمد</span>
                  </div>
                  <h5>{{ Number(totalSellPrice).toLocaleString() }} تومان</h5>
                </v-card>
              </v-col>
            </v-row>
            <hr />

            <div class="custom-table mt-3">
              <b-table
                responsive
                show-empty
                :current-page="currentPageCustomer"
                :per-page="perPageCustomer"
                :items="customers"
                :fields="customersFields"
                empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                empty-text="رکوردی برای نمایش وجود ندارد."
                striped
                thead-class="headClass"
                tbody-class="bodyClass"
              >
                <template v-slot:empty>
                  <div
                    style="text-align: center; vertical-align: middle"
                    class="pt-0"
                  >
                    رکوردی برای نمایش وجود ندارد.
                  </div>
                </template>
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 + perPage * (currentPage - 1) }}
                  </div>
                </template>

                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
              </b-table>
              <v-row class="mt-6">
                <v-col>
                  <div class="d-flex flex-row">
                    <span class="c-grey pt-2">نمایش در هر صفحه</span>
                    <div class="ms-3 me-3 number-box">
                      <v-select
                        outlined
                        v-model="perPageCustomer"
                        :items="perPageOptions"
                        @change="currentPageCustomer = 1"
                      ></v-select>
                    </div>
                  </div>
                </v-col>
                <v-col class="text-sm-center">
                  <div>
                    <v-pagination
                      v-model="currentPageCustomer"
                      :length="Math.ceil(customers.length / perPageCustomer)"
                      :total-visible="5"
                      prev-icon="$ArrowLeft"
                      next-icon="$ArrowRight"
                      class="float-sm-end"
                    ></v-pagination>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </div>
    <v-dialog v-model="increaseDialog" width="800">
      <v-card>
        <v-card-title class="white">
          <v-row>
            <v-col class="pe-0 pe-sm-4">
              <h4 class="c-grey mb-0">ورود کالا - افزایش موجودی</h4>
            </v-col>
            <v-col cols="2" class="text-left pt-2 pe-0 pe-sm-4">
              <span class="pointer" @click="increaseDialog = false"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <v-card-text>
          <v-row>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold"> تاریخ ورود:</label>
              <span id="date1">
                <v-text-field
                  placeholder="تاریخ ورود"
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-calendar"
                  v-model="selectedVariant.date"
                ></v-text-field>
              </span>
              <date-picker
                element="date1"
                v-model="selectedVariant.date"
                type="date"
                color="#6200ea"
              ></date-picker>
            </v-col>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold">ساعت ورود:</label>
              <span id="time1">
                <v-text-field
                  placeholder="ساعت ورود"
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-clock-outline"
                  v-model="selectedVariant.time"
                ></v-text-field>
              </span>
              <date-picker
                element="time1"
                v-model="selectedVariant.time"
                type="time"
                color="#6200ea"
              ></date-picker>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12">
              <label class="primary--text font-weight-bold"> حجم ورودی:</label>
              <v-text-field
                placeholder="حجم ورودی"
                outlined
                dense
                hide-details
                type="number"
                v-model="selectedVariant.number"
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12">
              <label class="primary--text font-weight-bold">مبدا:</label>
              <v-text-field
                placeholder="مبدا"
                outlined
                dense
                hide-details
                v-model="selectedVariant.origin"
              ></v-text-field>
            </v-col>
          </v-row>

          <label class="primary--text font-weight-bold">توضیحات:</label>
          <v-textarea
            placeholder="توضیحات"
            outlined
            dense
            v-model="selectedVariant.increaseDescription"
          ></v-textarea>
        </v-card-text>
        <div class="text-left py-3 px-4">
          <v-btn
            class="red-mainBtn white--text mx-2"
            @click="increaseDialog = false"
            width="90"
          >
            لغو
          </v-btn>
          <v-btn
            @click="entrySubmit()"
            :disabled="computedSubmitBtn"
            class="green-mainBtn white--text"
            width="90"
          >
            ثبت
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="decreaseDialog" width="800">
      <v-card>
        <v-card-title class="white">
          <v-row>
            <v-col class="pe-sm-4 pe-0 ps-sm-4 ps-0">
              <h4 class="c-grey mb-0">خروج کالا - کاهش موجودی</h4>
            </v-col>
            <v-col cols="2" class="text-left pt-2 pe-sm-4 ps-sm-4 ps-0 pe-0">
              <span class="pointer" @click="decreaseDialog = false"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <v-card-text>
          <v-row>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold"> تاریخ خروج:</label>
              <span id="date1">
                <v-text-field
                  placeholder="تاریخ خروج"
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-calendar"
                  v-model="selectedVariant.date"
                ></v-text-field>
              </span>
              <date-picker
                element="date1"
                v-model="selectedVariant.date"
                type="date"
                color="#6200ea"
              ></date-picker>
            </v-col>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold">ساعت خروج:</label>
              <span id="time1">
                <v-text-field
                  placeholder="ساعت خروج"
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-clock-outline"
                  v-model="selectedVariant.time"
                ></v-text-field>
              </span>
              <date-picker
                element="time1"
                v-model="selectedVariant.time"
                type="time"
                color="#6200ea"
              ></date-picker>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12">
              <label class="primary--text font-weight-bold"> حجم خروجی:</label>
              <v-text-field
                placeholder="حجم خروجی"
                outlined
                dense
                hide-details
                type="number"
                v-model="selectedVariant.number"
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12">
              <label class="primary--text font-weight-bold">مقصد:</label>
              <v-text-field
                placeholder="مقصد"
                outlined
                dense
                hide-details
                v-model="selectedVariant.origin"
              ></v-text-field>
            </v-col>
          </v-row>
          <label class="primary--text font-weight-bold pt-2">توضیحات:</label>
          <v-textarea
            placeholder="توضیحات"
            outlined
            dense
            v-model="selectedVariant.decreaseDescription"
          ></v-textarea>
        </v-card-text>
        <div class="text-left py-3 px-4">
          <v-btn
            class="red-mainBtn white--text mx-2"
            @click="decreaseDialog = false"
            width="90"
          >
            لغو
          </v-btn>
          <v-btn
            @click="exitSubmit()"
            :disabled="busy || computedSubmitBtn"
            class="green-mainBtn white--text"
            width="90"
          >
            ثبت
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addVarietyDialog" width="800">
      <v-card>
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0 pb-0" style="vertical-align: middle">
                افزودن تنوع
              </h4>
            </v-col>
            <v-col cols="2" class="text-left pt-2">
              <span class="pointer" @click="addVarietyDialog = false"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-0 pt-0" />
        <v-card-text class="pa-3">
          <v-row>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold">بارکد:</label>
              <v-text-field
                placeholder="بارکد"
                outlined
                dense
                v-model="newVariety.barcode"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col>
              <label class="primary--text font-weight-bold"
                >تاریخ اعتبار:</label
              >
              <span id="expireDateEdit">
                <v-text-field
                  placeholder="تاریخ اعتبار"
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-calendar"
                  v-model="newVariety.expireDate"
                ></v-text-field>
              </span>
              <date-picker
                element="expireDateEdit"
                v-model="newVariety.expireDate"
                type="date"
                color="#6200ea"
              ></date-picker>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0" md="6" cols="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> قیمت خرید (تومان):</label
              >
              <v-text-field
                placeholder="قیمت خرید (تومان)"
                outlined
                dense
                hide-details
                type="number"
                v-model="newVariety.buyPrice"
              ></v-text-field>
              <span v-show="newVariety.buyPrice" class="ps-2 pt-4"
                >{{
                  Number(newVariety.buyPrice / 10).toLocaleString()
                }}
                تومان</span
              >
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> قیمت فروش (تومان):</label
              >
              <v-text-field
                placeholder="قیمت فروش (تومان)"
                outlined
                dense
                hide-details
                type="number"
                v-model="newVariety.price"
              ></v-text-field>
              <span v-if="newVariety.price" class="ps-2 pt-4">
                {{ Number(newVariety.price / 10).toLocaleString() }}
                تومان</span
              >
            </v-col>
            <v-col
              md="6"
              cols="12"
              class="pt-0"
              v-if="selectedItem.isDiscounted"
            >
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> قیمت در تخفیف (تومان):</label
              >
              <v-text-field
                placeholder="قیمت در تخفیف (تومان)"
                outlined
                dense
                hide-details
                type="number"
                v-model="newVariety.discountedPrice"
              ></v-text-field>
              <span v-if="newVariety.discountedPrice" class="ps-2 pt-4">
                {{ Number(newVariety.discountedPrice / 10).toLocaleString() }}
                تومان</span
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">سال تولید:</label>
              <v-text-field
                placeholder="سال تولید"
                outlined
                dense
                v-model="newVariety.productionYear"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">
                کشور تولید کننده:
              </label>
              <v-text-field
                placeholder="کشور تولید کننده"
                outlined
                dense
                v-model="newVariety.producingCountry"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">رنگ:</label>
              <v-text-field
                placeholder="رنگ"
                outlined
                dense
                v-model="newVariety.color"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">کد رنگ:</label>
              <div class="color-box">
                <v-text-field
                  v-model="newVariety.colorCode"
                  hide-details
                  outlined
                  dense
                  @click="colorMenu = true"
                ></v-text-field>
                <v-menu
                  offset-y
                  v-model="colorMenu"
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      v-on="on"
                      class="color"
                      :style="'background-color:' + newVariety.colorCode"
                    ></div>
                  </template>
                  <div class="pa-0">
                    <v-color-picker
                      dot-size="15"
                      mode="hexa"
                      v-model="newVariety.colorCode"
                    ></v-color-picker>
                  </div>
                </v-menu>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"> سایز: </label>
              <v-text-field
                placeholder="سایز"
                outlined
                dense
                v-model="newVariety.size"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">حجم:</label>
              <v-text-field
                placeholder="حجم"
                outlined
                dense
                v-model="newVariety.volume"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"> ابعاد: </label>
              <v-text-field
                placeholder="ابعاد"
                outlined
                dense
                v-model="newVariety.dimension"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">وزن:</label>
              <v-text-field
                placeholder="وزن"
                outlined
                dense
                v-model="newVariety.weight"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> موجودی:
              </label>
              <v-text-field
                placeholder="موجودی"
                outlined
                dense
                v-model="newVariety.sum"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">
                ترکیبات و محتویات:
              </label>
              <v-text-field
                placeholder="ترکیبات و محتویات"
                outlined
                dense
                v-model="newVariety.contents"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="text-left pe-3 pb-4 mt-4">
            <v-btn
              class="green-mainBtn me-3"
              @click="addNewVariety()"
              :disabled="computedAddVarietyDis"
            >
              تایید
            </v-btn>
            <v-btn class="red-mainBtn" @click="addVarietyDialog = false">
              بستن
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="openEditDialog" width="800">
      <v-card>
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0 pb-0" style="vertical-align: middle">
                ویرایش تنوع
              </h4>
            </v-col>

            <v-col cols="2" class="text-left pt-2">
              <span class="pointer" @click="openEditDialog = false"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>

        <hr class="mt-0 pt-0" />
        <v-card-text class="pa-3">
          <v-row>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold">بارکد:</label>
              <v-text-field
                placeholder="بارکد"
                outlined
                dense
                v-model="selectedVariety.barcode"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col>
              <label class="primary--text font-weight-bold"
                >تاریخ اعتبار:</label
              >
              <span id="expireDateEdit">
                <v-text-field
                  placeholder="تاریخ اعتبار"
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-calendar"
                  v-model="selectedVariety.expireDate"
                ></v-text-field>
              </span>
              <date-picker
                element="expireDateEdit"
                v-model="selectedVariety.expireDate"
                type="date"
                color="#6200ea"
              ></date-picker>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0" md="6" cols="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> قیمت خرید (تومان):</label
              >
              <v-text-field
                placeholder="قیمت خرید (تومان)"
                outlined
                dense
                hide-details
                type="number"
                v-model="selectedVariety.buyPrice"
              ></v-text-field>
              <span v-show="selectedVariety.buyPrice" class="ps-2 pt-4"
                >{{
                  Number(selectedVariety.buyPrice / 10).toLocaleString()
                }}
                تومان</span
              >
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> قیمت فروش (تومان):</label
              >
              <v-text-field
                placeholder="قیمت فروش (تومان)"
                outlined
                dense
                hide-details
                type="number"
                v-model="selectedVariety.price"
              ></v-text-field>
              <span v-if="selectedVariety.price" class="ps-2 pt-4">
                {{ Number(selectedVariety.price / 10).toLocaleString() }}
                تومان</span
              >
            </v-col>
            <v-col
              md="6"
              cols="12"
              class="pt-0"
              v-if="selectedItem.isDiscounted"
            >
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> قیمت در تخفیف (تومان):</label
              >
              <v-text-field
                placeholder="قیمت در تخفیف (تومان)"
                outlined
                dense
                hide-details
                type="number"
                v-model="selectedVariety.discountedPrice"
              ></v-text-field>
              <span v-if="selectedVariety.discountedPrice" class="ps-2 pt-4">
                {{
                  Number(selectedVariety.discountedPrice / 10).toLocaleString()
                }}
                تومان</span
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">سال تولید:</label>
              <v-text-field
                placeholder="سال تولید"
                outlined
                dense
                v-model="selectedVariety.productionYear"
                hide-details
                type="number"
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">
                کشور تولید کننده:
              </label>
              <v-text-field
                placeholder="کشور تولید کننده"
                outlined
                dense
                v-model="selectedVariety.producingCountry"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">رنگ:</label>
              <v-text-field
                placeholder="رنگ"
                outlined
                dense
                v-model="selectedVariety.color"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">کد رنگ:</label>
              <div class="color-box">
                <v-text-field
                  v-model="selectedVariety.colorCode"
                  hide-details
                  outlined
                  dense
                  @click="editColorMenu = true"
                ></v-text-field>
                <v-menu
                  offset-y
                  v-model="editColorMenu"
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      v-on="on"
                      class="color"
                      :style="'background-color:' + selectedVariety.colorCode"
                    ></div>
                  </template>
                  <div class="pa-0">
                    <v-color-picker
                      dot-size="15"
                      mode="hexa"
                      v-model="selectedVariety.colorCode"
                    ></v-color-picker>
                  </div>
                </v-menu>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"> سایز: </label>
              <v-text-field
                placeholder="سایز"
                outlined
                dense
                v-model="selectedVariety.size"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">حجم:</label>
              <v-text-field
                placeholder="حجم"
                outlined
                dense
                v-model="selectedVariety.volume"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"> ابعاد: </label>
              <v-text-field
                placeholder="ابعاد"
                outlined
                dense
                v-model="selectedVariety.dimension"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">وزن:</label>
              <v-text-field
                placeholder="وزن"
                outlined
                dense
                v-model="selectedVariety.weight"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">
                ترکیبات و محتویات:
              </label>
              <v-text-field
                placeholder="ترکیبات و محتویات"
                outlined
                dense
                v-model="selectedVariety.contents"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="text-left pe-3 pb-4 mt-4">
            <v-btn
              class="green-mainBtn me-3"
              @click="editVariant()"
              :disabled="disableEdit"
            >
              تایید
            </v-btn>
            <v-btn class="red-mainBtn" @click="openEditDialog = false">
              بستن
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from "axios";
import MyCalendar from "../../components/MyCalendar.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { AtomSpinner } from "epic-spinners";
import Var from "../../../variables";
import moment from "moment-jalaali";
import VueCkeditor from "vue-ckeditor2";
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueCkeditor,
    AtomSpinner,
    MyCalendar,
    datePicker: VuePersianDatetimePicker,
    VueEditor,
  },
  data() {
    return {
      customToolbar: [
        [{ header: [2, 3, 4, false] }], // Add headings: H2, H3, H4
        ["bold", "italic", "underline"], // Text formatting options
        [{ list: "ordered" }, { list: "bullet" }],
        [{ color: [] }, { background: [] }], // Text color and background color
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ], // Align left, center, right, justify
        ["blockquote", "link"],
        [{ direction: "rtl" }, { direction: "ltr" }], // Right-to-left and left-to-right
      ],
      educationalStages: [],
      backEducationalStage: "",
      busy: false,
      singleExpand: false,
      expanded: [],

      publishers: [],
      moment: moment,
      increaseDialog: false,
      decreaseDialog: false,
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "Font",
            "FontSize",
          ],
        ],
      },
      openEditDialog: false,
      colorMenu: false,
      editColorMenu: false,
      headers: [
        { value: "mainVariant", text: "تنوع اصلی", sortable: false },
        { value: "expireDate", text: " تاریخ انقضا", sortable: false },
        { value: "barcode", text: "بارکد ", sortable: false },
        { value: "color", text: "رنگ", sortable: false },
        { value: "size", text: "سایز", sortable: false },
        { value: "volume", text: "حجم", sortable: false },
        { value: "dimension", text: "ابعاد", sortable: false },
        { value: "weight", text: "وزن", sortable: false },
        { value: "producingCountry", text: "کشور تولیدکننده", sortable: false },
        { value: "productionYear", text: "سال تولید", sortable: false },
        { value: "contents", text: "ترکیبات و محتویات", sortable: false },
        { value: "sum", text: " موجودی ", sortable: false },
        { value: "price", text: " قیمت ", sortable: false },
        // { value: "discountedPrice", text: "  قیمت در تخفیف ", sortable: false },
        { value: "data-table-expand", text: " عملیات ", sortable: false },
      ],
      variants: [],
      perPage: 5,
      perPageItems: [5, 10, 20],
      whichPage: 1,
      currentPage: 1,
      selectedItem: {},
      selectedVariety: {},
      selectedVariant: {},
      selectedIndex: "",
      newVariety: { colorCode: "#bf0000", mainVariant: false },
      newFileNames: [],
      editMainImage: [],
      editMyMainImage: new Object({
        uploadPercentage: 0,
      }),
      divisions: [],
      authors: [],
      educationalStage: [
        { key: null, text: "هیچکدام" },
        { key: "first", text: "اول" },
        { key: "second", text: "دوم" },
        { key: "third", text: "سوم" },
        { key: "fourth", text: "چهارم" },
        { key: "fifth", text: "پنجم" },
        { key: "sixth", text: "ششم" },
        { key: "seventh", text: "هفتم" },
        { key: "eighth", text: "هشتم" },
        { key: "ninth", text: "نهم" },
        { key: "tenth", text: "دهم" },
        { key: "eleventh", text: "یازدهم" },
        { key: "twelfth", text: "دوازدهم" },
      ],
      educationalGrades: [
        { key: null, text: "هیچکدام" },
        { key: "child", text: "کودک و نوجوان" },
        { key: "preSchool", text: "پیش دبستانی" },
        { key: "elementarySchool", text: "ابتدایی" },
        { key: "middleSchool", text: "متوسطه اول" },
        { key: "highSchool", text: "متوسطه دوم" },
      ],
      major: [
        { key: null, text: "هیچکدام" },
        { key: "mathematic", text: "ریاضی و فیزیک" },
        { key: "science", text: "علوم تجربی" },
        { key: "humanities", text: "علوم انسانی" },
      ],
      entranceExam: [
        { key: true, text: "بله" },
        { key: false, text: "خیر" },
      ],
      entranceExamMajor: [
        { key: null, text: "هیچکدام" },
        { key: "mathematic", text: "ریاضی و فیزیک" },
        { key: "science", text: "علوم تجربی" },
        { key: "humanities", text: "علوم انسانی" },
        { key: "art", text: "هنر" },
        { key: "vocational", text: "فنی و حرفه‌ای" },
        { key: "foreignLanguages", text: "زبان‌های خارجی" },
        { key: "allMajors", text: "عمومی" },
      ],
      generalSubject: [
        { key: null, text: "هیچکدام" },
        { key: "general", text: "جامع" },
        { key: "review", text: "جمع‌بندی" },
        { key: "stepbystep", text: "مبحثی" },
      ],
      editMainImageLoading: false,
      categories: [],
      brands: [],
      newTag: "",
      editNewTag: "",
      reactivity: false,
      galleryImage: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      editProductGallery: [],
      addVarietyDialog: false,
      editVarietyImage: [],
      editVarietyImageLoading: false,
      varietyImageLoading: false,
      editMyVarietyImage: new Object({
        uploadPercentage: 0,
      }),
      myVarietyImage: new Object({
        uploadPercentage: 0,
      }),
      tab: null,
      deviceType: "",
      startDate: "",
      endDate: "",
      currentDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      customers: [],
      excelFields: [
        { field: "name", label: "نام مشتری" },
        { field: "mobile", label: "تلفن همراه مشتری" },
        { field: "date", label: "تاریخ خرید" },
      ],
      customersFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام مشتری" },
        { key: "mobile", label: "تلفن همراه مشتری" },
        { key: "date", label: "تاریخ خرید" },
      ],
      totalInvoices: 0,
      totalSellAmount: 0,
      totalSellPrice: 0,
      currentPageCustomer: 1,
      perPageCustomer: 10,
      perPageOptions: [10, 25, 50],
    };
  },
  methods: {
    goToPage(item) {
      this.currentPage = Number(item);
    },
    deleteFile(index) {
      this.selectedItem.gallery.splice(index, 1);
    },
    // add image to product gallery
    editProductGalleryUpload(file) {
      // NOTE (m-myUpload) to upload files
      this.myFile.showProgress = true;
      this.myFile.variant = "info";
      this.myFile.uploadPercentage = 0;
      this.myFile.isUploaded = false;
      this.myFile.uploadButDisable = true;
      var formData = new FormData();

      formData.append(file.name, file);

      Axios.post(
        this.baseUrl +
          "/onlineShop/upload/warehouseItem/" +
          this.selectedItem.id,
        formData,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
          onUploadProgress: ((progressEvent) => {
            this.myFile.uploadPercentage =
              Math.round((progressEvent.loaded * 100) / progressEvent.total) -
              1;
          }).bind(this),
        }
      )
        .then((d) => {
          if (d.status == 200) {
            this.myFile.isUploaded = true;
            this.myFile.uploadPercentage = 100;
            this.myFile.striped = false;
            this.myFile.variant = "success";
            this.myFile.uploadButDisable = false;
            this.selectedItem.gallery.push(d.data);
            this.galleryIds.push(d.data.id);
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },

    divisionsList() {
      Axios.get(
        this.baseUrl +
          "/satrapp/divisions/list/" +
          this.selectedItem.publisherId,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )

        .then((res) => {
          if (res.status == 200) {
            this.divisions = res.data;
          }
        })
        .catch((err) => {
          this.toast.error(err.response.data);
        });
    },
    authorsList() {
      Axios.get(this.baseUrl + "/satrapp/authors/list", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })

        .then((res) => {
          if (res.status == 200) {
            this.authors = res.data;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    goToOnlineShop() {
      let link = "/productdetails/" + this.$route.params.id;
      window.open(link, "_blank");
    },
    removeTag(dataName, index) {
      this[dataName].tags.splice(index, 1);
      this.reactivity = !this.reactivity;
    },
    openDialog(type) {
      this.selectedItem.date = moment(new Date()).format("jYYYY/jMM/jDD HH:mm");
      if (type == "increase") {
        this.increaseDialog = true;
      } else if (type == "decrease") {
        this.decreaseDialog = true;
      }
    },
    entrySubmit() {
      this.busy = true;
      Axios.post(
        this.baseUrl + "/satrapp/warehouse/exchanges/entrance",
        {
          warehouseItemId: this.$route.params.id,
          amount: this.selectedVariant.number,
          date: this.selectedVariant.date + " " + this.selectedVariant.time,
          orgDes: this.selectedVariant.origin,
          note: this.selectedVariant.increaseDescription,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.increaseDialog = false;
            // this.getVariantsInfo();
            // this.submit();
            this.busy = false;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید", "error");
            this.busy = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.busy = false;
        });
    },
    exitSubmit() {
      Axios.post(
        this.baseUrl + "/satrapp/warehouse/exchanges/exit/",
        {
          warehouseItemId: this.$route.params.id,
          // warehouseId: "6174364e034d1b5b3b880f6b",
          amount: this.selectedVariant.number,
          date: this.selectedVariant.date + " " + this.selectedVariant.time,
          orgDes: this.selectedVariant.origin,
          note: this.selectedVariant.decreaseDescription,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.decreaseDialog = false;
            this.getVariantsInfo();
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },

    editDialog(item, index) {
      this.selectedVariety = JSON.parse(JSON.stringify(item));
      this.selectedVariety.colorCode = item.colorCode
        ? item.colorCode
        : "#bf0000";
      (this.selectedIndex = index), (this.openEditDialog = true);
    },
    editVariant() {
      setTimeout(() => {
        Axios.patch(
          this.baseUrl +
            "/satrapp/warehouse/warehouseItem/editVariant/" +
            this.selectedVariety.id,
          {
            color: this.selectedVariety.color,
            colorCode: this.selectedVariety.colorCode,
            size: this.selectedVariety.size,
            volume: this.selectedVariety.volume,
            dimension: this.selectedVariety.dimension,
            weight: this.selectedVariety.weight,
            producingCountry: this.selectedVariety.producingCountry,
            productionYear: this.selectedVariety.productionYear,
            contents: this.selectedVariety.contents,
            expireDate: this.selectedVariety.expireDate,
            price: Number(this.selectedVariety.price),
            buyPrice: Number(this.selectedVariety.buyPrice),
            sum: Number(this.selectedVariety.sum)
              ? Number(this.selectedVariety.sum)
              : 0,
            barcode: this.selectedVariety.barcode,
            discountedPrice: this.selectedItem.isDiscounted
              ? this.selectedVariety.discountedPrice
              : undefined,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              this.toast(res.data.message, "success");
              this.variants[this.selectedIndex] = this.selectedVariety;
              this.openEditDialog = false;
              this.selectedVariety = {};
              this.selectedIndex = "";
              this.getVariantsInfo();
            } else {
              const title = (
                <div>
                  <h5>خطا </h5>
                  <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
                </div>
              );
              this.toast(title, "error");
            }
          })
          .catch((err) => {
            this.toast("خطا: " + err.response.data, "error");
            this.variants[this.selectedIndex] = this.selectedVariety;
            this.openEditDialog = false;
            this.selectedVariety = {};
            this.selectedIndex = "";
          });
      }, 500);
    },
    async getProductInfo() {
      this.galleryImage = [];
      this.myFile = new Object({
        uploadPercentage: 0,
      });
      await Axios.post(
        this.baseUrl + "/satrapp/warehouse/warehouseItem/getInfo",
        {
          warehouseItemId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.selectedItem = res.data;
            this.selectedItem.publisherId = res.data.publisherId;
            this.divisionsList();
            this.variants = res.data.variants;
            this.backEducationalStage = res.data.educationalStage;
            this.selectedItem.authors = res.data.authors.map((item) => item.id);
            this.educationalStages = this.backEducationalStage
              .split(",")
              .map((stage) => stage.trim());
            // this.properties = res.data.properties;
            // this.properties.forEach((element) => {
            //   if (element.type == "number") {
            //     this.property[element.fieldName] = Number(element.value);
            //   } else {
            //     this.property[element.fieldName] = element.value;
            //   }
            // });

            // this.selectedItem.id = item.id;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    addVariety() {
      this.addVarietyDialog = true;
      this.newVariety = { colorCode: "#bf0000", mainVariant: false };
    },

    addNewVariety() {
      Axios.post(
        this.baseUrl +
          "/satrapp/warehouse/warehouseItem/addVariation/" +
          this.$route.params.id,
        {
          variants: [
            {
              color: this.newVariety.color,
              colorCode: this.newVariety.colorCode,
              size: this.newVariety.size,
              volume: this.newVariety.volume,
              dimension: this.newVariety.dimension,
              weight: this.newVariety.weight,
              producingCountry: this.newVariety.producingCountry,
              productionYear: this.newVariety.productionYear,
              contents: this.newVariety.contents,
              expireDate: this.newVariety.expireDate,
              price: Number(this.newVariety.price),
              buyPrice: Number(this.newVariety.buyPrice),
              sum: Number(this.newVariety.sum),
              barcode: this.newVariety.barcode,
              discountedPrice: this.selectedItem.isDiscounted
                ? this.newVariety.discountedPrice
                : undefined,
            },
          ],
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.addVarietyDialog = false;
            // this.getVariantsInfo();
            this.toast(res.data.message, "success");
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
            this.addVarietyDialog = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.addVarietyDialog = false;
        });
    },
    editItem() {
      this.busy = true;
      let myGalleryIds = this.selectedItem.gallery.map((x) => x.id);
      let educationalStages = this.educationalStages
        ? this.educationalStages.join()
        : "";
      Axios.post(
        this.baseUrl + "/satrapp/warehouse/warehouseItem/edit",
        {
          warehouseItemId: this.$route.params.id,
          name: this.selectedItem.name,
          pictureId: this.selectedItem.pictureId
            ? this.selectedItem.pictureId
            : undefined,
          subTitle: this.selectedItem.subTitle,
          subject: this.selectedItem.subject,
          price: this.selectedItem.price,
          isbn: this.selectedItem.isbn,
          publishYear: this.selectedItem.publishYear,
          publisherId: this.selectedItem.publisherId
            ? this.selectedItem.publisherId
            : undefined,
          educationalStage: educationalStages,
          educationalGrade: this.selectedItem.educationalGrade,
          major: this.selectedItem.major,
          divisionId: this.selectedItem.divisionId
            ? this.selectedItem.divisionId
            : undefined,
          entranceExam: this.selectedItem.entranceExam,
          entranceExamMajor: this.selectedItem.entranceExamMajor,
          generalSubject: this.selectedItem.generalSubject,
          authorIds: this.selectedItem.authors
            ? this.selectedItem.authors
            : undefined,
          tags: this.selectedItem.tags,
          onlineShopDescription: this.selectedItem.onlineShopDescription,
          sellDescription: this.selectedItem.sellDescription,
          ogDescription: this.selectedItem.ogDescription,
          aparatAuthorLink: this.selectedItem.aparatAuthorLink,
          aparatExpertLink: this.selectedItem.aparatExpertLink,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            // this.$router.push("/shop/products");
            this.busy = false;
            this.$router.back();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.busy = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.busy = false;
        });
    },
    editProductMainImageUpload(file) {
      if (!file) {
        return;
      }
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 5 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else if (file.type != "image/jpeg" && file.type != "image/png") {
        this.toast("فرمت فایل مورد نظر مجاز نمی‌باشد.", "error");
        return;
      } else {
        // NOTE (m-myUpload) to upload files
        this.editMyMainImage.showProgress = true;
        this.editMyMainImage.variant = "info";
        this.editMyMainImage.uploadPercentage = 0;
        this.editMyMainImage.isUploaded = false;
        this.editMyMainImage.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);
        this.editMainImageLoading = true;
        Axios.post(
          this.baseUrl +
            "/onlineShop/upload/warehouseItem/" +
            this.selectedItem.id,
          formData,
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
            onUploadProgress: ((progressEvent) => {
              this.editMyMainImage.uploadPercentage =
                Math.round((progressEvent.loaded * 100) / progressEvent.total) -
                1;
            }).bind(this),
          }
        )
          .then((d) => {
            if (d.status == 200) {
              this.editMyMainImage.isUploaded = true;
              this.editMyMainImage.uploadPercentage = 100;
              this.editMyMainImage.striped = false;
              this.editMyMainImage.variant = "success";
              this.editMyMainImage.uploadButDisable = false;
              this.selectedItem.pictureId = d.data.id;
              this.selectedItem.pictureUrl = d.data.url;
              this.editMainImageLoading = false;
            }
          })
          .catch((err) => {
            this.toast(err.response.data, "error");
            this.editMainImageLoading = false;
          });
      }
    },
    getPublishersList() {
      Axios.get(this.baseUrl + "/satrapp/publishers/list", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.publishers = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    addNewTag(dataName) {
      if (dataName == "newItem") {
        if (!this.newItem.tags.includes(this.newTag.trim())) {
          this.newItem.tags.push(this.newTag.trim());
          this.newTag = "";
        } else {
          this.$toast("این تگ پیش از این افزوده شده است.", "error");
        }
      } else {
        if (!this.selectedItem.tags.includes(this.editNewTag.trim())) {
          this.selectedItem.tags.push(this.editNewTag.trim());
          this.editNewTag = "";
        } else {
          this.$toast("این تگ پیش از این افزوده شده است.", "error");
        }
      }
    },
    cancelEdit() {
      this.selectedItem = {};
      window.close();
      this.$router.push("/shop/products");
    },
    editMainVariant(index) {
      this.selectedIndex = index + this.perPage * (this.currentPage - 1);

      Axios.patch(
        this.baseUrl +
          "/satrapp/warehouse/warehouseItem/editMainVariant/" +
          this.$route.params.id,
        {
          mainVariantId: this.variants[this.selectedIndex].id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.variants.forEach((x) => (x.mainVariant = false));
            this.variants[this.selectedIndex].mainVariant = true;
            this.selectedIndex = "";
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.selectedIndex = "";
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.selectedIndex = "";
        });
    },

    productSales() {
      this.loading = true;
      Axios.post(
        this.baseUrl + "/satrapp/warehouse/warehouseItem/saleReport",
        {
          startDate: this.startDate,
          endDate: this.endDate,
          warehouseItemId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            this.totalInvoices = res.data.totalInvoices;
            this.totalSellAmount = res.data.totalSellAmount;
            this.totalSellPrice = res.data.totalSellPrice;
            this.customers = res.data.customers;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
        });
    },
  },
  mounted() {
    if (window.screen.width < 768) {
      this.deviceType = "mobile";
    } else {
      this.deviceType = "desktop";
    }
    this.startDate = moment(this.currentDate, "jYYYY/jMM/jDD").format("X");
    this.startDate = this.startDate - 7 * 86400;
    this.startDate = moment(this.startDate, "X").format("jYYYY/jMM/jDD");
    this.endDate = this.currentDate;
    this.getProductInfo();
    this.getPublishersList();
    this.authorsList();
  },
  computed: {
    linkRules() {
      return [
        (v) => /^(ftp|http|https):\/\/[^ "]+$/.test(v) || "لینک معتبر نیست",
      ];
    },
    computedSubmitBtn() {
      if (
        this.selectedVariant.date &&
        this.selectedVariant.time &&
        this.selectedVariant.number &&
        this.selectedVariant.origin
      ) {
        return false;
      } else return true;
    },

    computedAddVarietyDis() {
      if (
        this.newVariety.price &&
        this.newVariety.buyPrice &&
        this.newVariety.sum
      ) {
        return false;
      }
      return true;
    },
    computedVariant() {
      if (this.selectedItem.name && this.variants.length) {
        let arr = [];
        this.variants.forEach((x) => arr.push(x.mainVariant));
        for (let i = 0; i < arr.length; i++) {
          if ((arr[i] = true)) {
            return false;
          } else return true;
        }
      } else return true;
    },
    disableEdit() {
      if (this.selectedVariety.price && this.selectedVariety.buyPrice) {
        return false;
      } else return true;
    },
    computedIndex() {
      let arr = [];
      let computedLength = this.variants.length;
      let arrLength = Math.ceil(computedLength / this.perPage);
      for (let i = 1; i <= arrLength; i++) {
        arr.push(i);
      }
      return arr;
    },
  },
};
</script>
<style lang="scss">
.edit-product {
  .custom-input {
    .v-input__slot {
      width: 100% !important;
    }

    .v-input__control {
      flex-direction: row !important;
    }

    .v-text-field .v-input__control,
    .v-text-field fieldset {
      min-height: 45px !important;
      border-color: #4ba0e7 !important;
    }

    .v-label:not(.v-label--active) {
      transform: translateY(2px);
    }

    .theme--light.v-data-table .v-data-table-header th.sortable:hover {
      color: white !important;
    }

    .theme--light.v-data-table
      > .v-data-table__wrapper
      > table
      > thead
      > tr
      > th {
      color: white !important;
    }

    .v-data-table
      > .v-data-table__wrapper
      tbody
      tr.v-data-table__expanded__content {
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
    }

    .theme--light.v-card > .v-card__subtitle,
    .theme--light.v-card > .v-card__text {
      color: black !important;
    }

    .theme--light.v-data-table {
      background-color: #fff;
      color: black !important;
    }

    table thead {
      color: black !important;
    }

    .custom-table-vue .v-data-table-header tr th {
      text-align: center !important;
      font-size: 15px !important;
      color: black !important;
      height: 50px !important;
    }
  }
}

.color-box {
  direction: ltr;
  display: flex;
  border: none !important;

  .color {
    width: 40px;
    height: 40px;
    // margin-top: 8px;
  }
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 8px !important;
}

.files-box {
  border: 1px solid rgb(172, 172, 172);
  text-align: right;
  font-size: 14px;
  margin-top: 35px;
  padding: 10px;
  border-radius: 7px;
  position: relative;

  ul {
    li {
      text-decoration: none;
    }
  }

  .files-title {
    position: absolute;
    top: -9px;
    right: 20px;
    background-color: #fff;
    font-size: 14px;
    padding: 0 6px;
  }
}

.img-box {
  border-radius: 30px;
  position: relative;
  overflow: hidden;
  width: 170px;
  height: 170px;
  border: none;

  &:hover {
    background-color: #3c03923b !important;

    .img {
      opacity: 0.7;
    }

    .img-icon {
      display: block;
    }
  }

  .img {
    opacity: 1;
    width: 100%;
    height: 100%;
  }

  .img-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: none;
  }

  .img-loading {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #3c03923b;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}
</style>
